import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
class ErrorBoundaryInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(_error) {
        return { hasError: true };
    }
    componentDidUpdate(prevProps, _previousState) {
        if (!this.props.hasError && prevProps.hasError) {
            this.setState({ hasError: false });
        }
    }
    componentDidCatch(_error, _errorInfo) {
        this.props.setHasError(true);
    }
    render() {
        return this.state.hasError ? (_jsx("h1", { children: "There was an error" })) : (this.props.children);
    }
}
export const ErrorBoundary = ({ children }) => {
    const [hasError, setHasError] = useState(false);
    const location = useLocation();
    useEffect(() => {
        if (hasError) {
            setHasError(false);
        }
    }, [location.key]);
    return (_jsx(ErrorBoundaryInner, { hasError: hasError, setHasError: setHasError, children: children }));
};
